export const SET_ACCOUNTING_SETTINGS = "SET_ACCOUNTING_SETTINGS";
export const SET_DOCS_SETTINGS = "SET_DOCS_SETTINGS";
export const SET_SUPPORT_SETTINGS = "SET_SUPPORT_SETTINGS";
export const SET_ACCOUNT_NAME_SETTINGS = "SET_ACCOUNT_NAME_SETTINGS";
export const SET_SETTINGS = "SET_SETTINGS";
export const SET_VALID_SETTINGS = "SET_VALID_SETTINGS";
